import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { IonItem, IonLabel, IonList, IonNote } from '@ionic/angular/standalone';

import { GuardFinderError } from '../../../../services';
import { AlertModalContentComponent } from '../alert-modal-content/alert-modal-content.component';

/**
 * AlertModalTypedErrorsComponent
 *
 * Displays a list of typed (structured) errors in a modal dialog.
 * Intended for use in GuardFinder to show validation or domain errors to users in a clear, organized format.
 *
 * Inputs:
 *   - errors: An array of GuardFinderError objects representing the errors to display.
 *
 * It's used in the LaravelApiClientService to display errors in a modal dialog.
 *
 * This component is standalone and uses Ionic and Angular CommonModule for UI rendering.
 */
@Component({
    selector: 'lib-alert-modal-typed-errors',
    standalone: true,
    imports: [CommonModule, AlertModalContentComponent, IonItem, IonList, IonLabel, IonNote],
    templateUrl: './alert-modal-typed-errors.component.html'
})
export class AlertModalTypedErrorsComponent {
    @Input({ required: true }) errors: GuardFinderError[] = [];
}
